/**
 * @generated SignedSource<<da249cc931305d64774edbd623a1648e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedTrackingContainer_user$data = {
  readonly serviceId: string | null;
  readonly isVerifiedTrade: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"SharedTrackingContainer_user">;
  readonly " $fragmentType": "SbSharedTrackingContainer_user";
};
export type SbSharedTrackingContainer_user$key = {
  readonly " $data"?: SbSharedTrackingContainer_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedTrackingContainer_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedTrackingContainer_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVerifiedTrade",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedTrackingContainer_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "ed8c22748cc9074e7803de32918e8933";

export default node;
